import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import FavoriteSuggestion from '../../types/FavoriteSuggestion';
import FavoriteSuggestionType from '../../types/FavoriteSuggestionType';
import { isCategoryInFavorites } from 'owa-favorites';
import { getCategorySuggestions, getMasterCategoryList } from 'owa-categories';

/**
 * Get the favorite category suggestions based on the find text that user types
 * @param findText the find text in the favorite picker search box
 * @return an array of favorite category suggestions
 */
export default function getFavoriteCategorySuggestions(findText: string): FavoriteSuggestion[] {
    const categorySuggestions = getCategorySuggestions(findText, getMasterCategoryList());
    const categoryFavoriteSuggestions = [];

    for (const categorySuggestion of categorySuggestions.suggestions) {
        if (!isCategoryInFavorites(categorySuggestion.Id)) {
            categoryFavoriteSuggestions.push({
                data: categorySuggestion.Name,
                id: categorySuggestion.Id,
                type: FavoriteSuggestionType.Category,
                relevance: 0 /* Relevance scores will be supplied by providers in the future */,
            });
        }
    }

    const maxCategorySuggestions = getMaxFavoriteSuggestionCounts().category;
    categoryFavoriteSuggestions.splice(maxCategorySuggestions);
    return categoryFavoriteSuggestions;
}
